"use strict";

jQuery(function($) {
    
    $(document).on('change', '[data-filter-festival-select]', function(e) {

        if (!$('[data-filter-festival-target]').length) {
            return;
        }

        var $target = $('[data-filter-festival-target]');
        var data = {};
        var arrayFormat = /\[.*?\]$/;

        // Convert array to object
        $('[data-filter-festival-select]').each(function() {
            var key = $(this).attr("name");
            var value = $(this).val();

            // Check if array format
            if (arrayFormat.test(key)) {
                key = key.replace(arrayFormat, '');
                value = key in data ? data[key].concat(value) : [value];
            }

            if (value !== '') {
               data[key] = value; 
            }
        });

        
        $.ajax({
            url      : themevars.ajaxurl,
            data     : {
                'action' : 'festival_filter_list',
                'post_id' : themevars.post_id,
                'data' : data,
            },
            type     : 'POST',
            dataType : 'json'
        }).done( function(result) {

            $target.empty();

            if (true !== result.success || undefined === result.data.posts) {
                $target.append('<div class="col-12 text-center no-results-message">Geen resultaten</div>');
                return;
            }

            $target.append(result.data.posts);
        } );
    });
});

